const _ = require('./utils')

Component({
  data: {
    flag: false,
    // 控制下拉菜单显示
    selectFlag: false,
    // 当前选中的值
    selectiVal: null,
    // 当前选中值的id
    selectiID: null
  },

  properties: {
    // 边框颜色
    selectBorder: {
      type: String,
      value: '#ededed'
    },
    // 边框圆角
    selectBRadius: {
      type: Number,
      value: 16
    },
    // 文字颜色
    textColor: {
      type: String,
      value: 'rgba(141, 144, 166, 1)'
    },
    // 文字大小
    textSize: {
      type: Number,
      value: 25
    },
    // icon
    icon: {
      type: String,
      value: null
    },
    // icon 大小
    iconSize: {
      type: Number,
      value: 48
    },
    // 下拉菜单数据
    selectList: {
      type: Array,
      value: []
    },
    // 当前选中的id
    newID: {
      type: Number,
      value: -1
    },
    // 当前选中的名字
    newName: {
      type: String,
      value: '',
      observer() {
        this.setData({
          selectiVal: this.properties.newName,
          selectiID: this.properties.newID
        })
      }
    },
    // 默认显示的内容
    placeholder: {
      type: String,
      value: '请选择'
    },
    // 是否可以输入
    isInput: {
      type: Boolean,
      value: false
    },
    // 选择框背景色
    selectiBg: {
      type: String,
      value: '#ffffff'
    },
    // 点击外部是否可以关闭下拉菜单
    exterior: {
      type: Boolean,
      value: true
    }
  },

  methods: {
    // 展开或收起下拉框
    unfold: _.debounce(function () {
      this.setData({
        selectFlag: !this.data.selectFlag
      })
    }, 200),

    // 选则下拉框数据
    changecontent(e) {
      const item = e.currentTarget.dataset.item
      this.setData({
        selectFlag: false,
        selectiVal: item.text,
        selectiID: item.id
      })

      // 把选择好的数据传给父组件
      this.triggerEvent('handleChange', {
        selectiVal: item.text,
        selectiID: item.id
      })
    },

    // 输入
    onInput(e) {
      this.setData({
        selectiVal: e.detail.value
      })
    },

    // 确认
    onConfirm() {
      const {
        selectFlag,
        selectiVal
      } = this.data

      this.setData({
        selectFlag: selectFlag ? false : selectFlag
      })

      // 把选择好的数据传给父组件
      this.triggerEvent('handleChange', {
        selectiVal,
        selectiID: ''
      })
    },

    // 输入框失去焦点
    onBlur() {
      this.setData({
        selectFlag: false
      })

      if (this.data.selectiVal) {
        this.triggerEvent('handleChange', {
          selectiVal: this.data.selectiVal,
          selectiID: ''
        })
      }
    },

    // 点击外部收起下拉框
    closeSelectBox() {
      this.setData({
        selectFlag: false
      })
    }
  },

  lifetimes: {
    attached() {
      wx.getSystemInfo({
        success: () => {
          this.setData({
            flag: _.getFlag(),
          })
        }
      })
    }
  }
})
